<template>
  <v-container fluid class="pa-6 grey lighten-4 fill-height align-start">
    <v-row>
      <!-- LEFT PANEL: Invoice Header & Client Details -->
      <v-col cols="12" md="5" lg="4">
        <v-card outlined class="elevation-2 mb-4 pa-2">
          <v-toolbar flat color="primary" dark class="rounded-t">
            <v-toolbar-title class="headline font-weight-bold">
              Račun Fiskalizacija 1.0 - DEMO!!!
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text class="pt-6">
            <!-- Inline Date and Time Fields -->
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="document.documentDate"
                  label="Datum"
                  type="date"
                  outlined
                  class="accessible-field"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="document.documentTime"
                  label="Vrijeme"
                  type="time"
                  outlined
                  class="accessible-field"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>

            <!-- Toggle: Retail vs Company -->
            <v-btn-toggle
              v-model="customerType"
              mandatory
              color="primary"
              class="mb-6 d-flex border-all"
              height="54"
            >
              <v-btn value="private" class="flex-grow-1 text-none body-1 font-weight-medium">Privatni kupac</v-btn>
              <v-btn value="company" class="flex-grow-1 text-none body-1 font-weight-medium">Firma</v-btn>
            </v-btn-toggle>

            <!-- Adaptive Customer Inputs -->
            <v-form ref="customerForm">
              <v-slide-y-transition mode="out-in">
                <!-- Case A: Private Person -->
                <div v-if="customerType === 'private'" key="private">

                  <v-combobox
                    v-model="selectedPrivateClient"
                    :items="savedPrivateClients"
                    item-text="partnerName"
                    label="Traži/Dodaj privatnog kupca"
                    placeholder="Utipkajte ime..."
                    outlined
                    class="accessible-field"
                    clearable
                    @change="onPrivateClientSelect"
                  ></v-combobox>
                  
                  <div v-if="showPrivateVat || document.partnerVATID">
                    <v-row class="align-center mt-n6" dense>
                      <v-col cols="8">
                        <v-text-field
                          v-model="invoice.vatId"
                          label="Osobni OIB"
                          outlined
                          class="accessible-field"
                          append-icon="mdi-close"
                          @click:append="showPrivateVat = false; invoice.vatId = ''"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="align-center mt-n7" dense>
                      <v-col cols="8">
                        <v-text-field
                          v-model="document.partnerStreet"
                          label="Ulica"
                          outlined
                          class="accessible-field "
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="document.partnerBuildingNameNumber"
                          label="Broj"
                          outlined
                          class="accessible-field "
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="align-center" dense>
                      <v-col cols="8">
                        <v-text-field
                          v-model="document.partnerCity"
                          label="Grad"
                          outlined
                          class="accessible-field "
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="document.partnerPostcode"
                          label="Pošt.broj"
                          outlined
                          class="accessible-field "
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                 
                  <div v-else class="text-right mt-n4 mb-4">
                    <v-btn text color="primary" @click="showPrivateVat = true" class="body-1 font-weight-bold">
                      + Dodaj podatke
                    </v-btn>
                  </div>
                </div>

                <!-- Case B: Company -->
                <div v-else key="company">
                  <v-combobox
                    v-model="selectedCompanyClient"
                    :items="savedCompanies"
                    item-text="partnerName"
                    label="Traži spremljenu Firmu"
                    outlined
                    class="accessible-field mb-4"
                    clearable
                    @change="onCompanySelect"
                  ></v-combobox>

                  <v-row class="align-center">
                    <v-col cols="8">
                      <v-text-field
                        v-model="document.partnerVATID"
                        label="Firma OIB *"
                        outlined
                        class="accessible-field"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-btn block color="secondary" height="56" outlined @click="verifyVatCompany" class="body-1">
                        PROVJERI
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-text-field
                    v-model="document.partnerName"
                    label="Naziv firme *"
                    outlined
                    class="accessible-field mt-4"
                    hide-details
                  ></v-text-field>

                   <v-row class="align-center">
                    <v-col cols="8">
                      <v-text-field
                        v-model="document.partnerStreet"
                        label="Ulica"
                        outlined
                        class="accessible-field mt-4"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="document.partnerBuildingNameNumber"
                        label="Broj"
                        outlined
                        class="accessible-field mt-4"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="align-center" dense>
                    <v-col cols="8">
                      <v-text-field
                        v-model="document.partnerCity"
                        label="Grad"
                        outlined
                        class="accessible-field mt-4"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="document.partnerPostcode"
                        label="Pošt.broj"
                        outlined
                        class="accessible-field mt-4"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  
                </div>
              </v-slide-y-transition>

              <v-checkbox
                v-model="invoice.saveToDb"
                label="Spremi/Update u bazu"
                color="primary"
                class="mt-4 v-input--accessible-checkbox"
                hide-details
              ></v-checkbox>

              <v-divider class="my-4"></v-divider>

              <!-- Global Tax Flag -->
              <v-switch 
                v-model="invoice.applyVat" 
                color="success" 
                hide-details 
                label="Primjeni PDV"
                class="v-input--accessible-switch"
              ></v-switch>

              <v-divider class="my-4"></v-divider>

              <!-- Collapsible Comment Field -->
              <v-expansion-panels flat tile class="grey lighten-5 border-all">
                <v-expansion-panel class="transparent">
                  <v-expansion-panel-header class="px-4 py-3 body-1 font-weight-medium text--secondary">
                    <span><v-icon left>mdi-comment-text-outline</v-icon> Dodaj napomenu</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-textarea v-model="invoice.comment" outlined rows="2" class="accessible-field" hide-details></v-textarea>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- RIGHT PANEL: Main Workspace (Search, Interactive Cart Matrix, Payments) -->
      <v-col cols="12" md="7" lg="8">
        <v-card outlined class="elevation-2 d-flex flex-column pa-2" style="min-height: 800px;">
          <v-toolbar flat color="grey lighten-3" class="rounded-t">
            <v-toolbar-title class="headline font-weight-bold grey--text text--darken-3">
              Stavke računa
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text class="flex-grow-1 pa-4 d-flex flex-column">
            <!-- Search & Add Items (DB Lookup or Custom string generation) -->
            <v-combobox
              v-model="itemSearchModel"
              :items="itemDatabase"
              item-text="itemName"
              label="Skeniraj kod ili upiši naziv ..."
              outlined
              prepend-inner-icon="mdi-barcode-scan"
              clearable
              return-object
              class="accessible-field mb-4"
              @change="handleItemSelection"
            >
              <template v-slot:no-data>
                <v-list-item @click="addCustomItemDirectly" class="py-2">
                  <v-list-item-content>
                    <v-list-item-title class="body-1">
                      Ne mogu pronaći. Kliknite  <strong class="primary--text">"{{ itemSearchModel }}"</strong> da spremite artikal/uslugu.
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>

            <!-- Interactive Spreadsheet Workspace Table (Enlarged Fonts and Paddings) -->
            <v-simple-table class="border-all flex-grow-1 accessible-table">
              <template v-slot:default>
                <thead>
                  <tr class="grey lighten-4">
                    <th class="text-left body-1 font-weight-bold" style="width: 30%;">Naziv</th>
                    <th class="text-center body-1 font-weight-bold" style="width: 10%;">Kol</th>
                    <th class="text-right body-1 font-weight-bold" style="width: 15%;">Neto cijena(€)</th>
                    <th class="text-center body-1 font-weight-bold" style="width: 15%;">PDV %</th>
                    <th class="text-right body-1 font-weight-bold" style="width: 12%;">Popust(€)</th>
                    <th class="text-right body-1 font-weight-bold" style="width: 15%;">Bruto (€)</th>
                    <th class="text-center" style="width: 3%;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in cartItems" :key="index" class="table-row-large">
                    <!-- Item Name -->
                    <td>
                      <v-text-field v-model="item.name" hide-details class="pt-0 mt-0 plain-text-field body-1 font-weight-medium"></v-text-field>
                    </td>
                    <!-- Quantity -->
                    <td class="text-center">
                      <v-text-field v-model.number="item.qty" type="number" hide-details class="pt-0 mt-0 center-input body-1" style="width: 70px; margin: 0 auto;"></v-text-field>
                    </td>
                    <!-- Original Base Net Price -->
                    <td class="text-right">
                      <v-text-field v-model.number="item.basePrice" type="number" step="0.01" hide-details class="pt-0 mt-0 right-input body-1" style="width: 90px; margin-left: auto;" @input="recalculateFromBase(item)"></v-text-field>
                    </td>
                    <!-- Tax Rate Selection Tier Dropdown -->
                    <td class="text-center">
                      <v-select
                        v-model="item.taxRate"
                        :items="taxTiers"
                        item-text="label"
                        item-value="value"
                        hide-details
                        class="pt-0 mt-0 body-1 plain-text-field center-input font-weight-medium"
                        style="width: 110px; margin: 0 auto;"
                        @change="recalculateFromBase(item)"
                      ></v-select>
                    </td>
                    <!-- Flat Discount Input Field -->
                    <td class="text-right">
                      <v-text-field v-model.number="item.discount" type="number" step="0.01" hide-details class="pt-0 mt-0 right-input body-1 red--text font-weight-medium" style="width: 80px; margin-left: auto;" @input="recalculateFromDiscount(item)"></v-text-field>
                    </td>
                    <!-- Target Gross Input (Modifies values backwards to balance books natively) -->
                    <td class="text-right">
                      <v-text-field v-model.number="item.targetGross" type="number" step="0.01" hide-details class="pt-0 mt-0 right-input font-weight-bold generic-gross-field body-1" style="width: 100px; margin-left: auto;" @input="recalculateFromTargetGross(item)"></v-text-field>
                    </td>
                    <!-- Delete Item Row Button -->
                    <td class="text-center">
                      <v-btn icon color="error" @click="removeItem(index)"><v-icon>mdi-delete</v-icon></v-btn>
                    </td>
                  </tr>
                  <tr v-if="cartItems.length === 0">
                    <td colspan="7" class="text-center py-16 title grey--text text--darken-1">
                      Nema stavka na računu. Skenirajte kod ili upišite naziv...
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <!-- BOTTOM SECTION: Multi-tax Itemized Recaps & Inline Card Payment Processor Matrix -->
          <v-card-text class="grey lighten-4 border-top pa-6">
            <v-row class="align-center">
              <!-- Tax Breakdown Block Engine summary profiles -->
              <v-col cols="12" md="5" class="d-flex flex-column justify-center py-0">
                <div class="d-flex justify-space-between mb-2 body-1 text--secondary">
                  <span>Neto ukupno:</span><span>{{ localMoney(totals.subtotal) }} €</span>
                </div>
                <!-- Mini Tax Ledger per tier layer -->
                <div v-for="(amount, rate) in totals.taxLedger" :key="rate" class="d-flex justify-space-between mb-2 body-1 grey--text text--darken-2">
                  <span>PDV stopa ({{ (rate * 100) }}%):</span><span>{{ localMoney(amount) }} €</span>
                </div>
                <v-divider class="my-3"></v-divider>
                <div class="d-flex justify-space-between align-center">
                  <span class="headline font-weight-bold">Ukupno:</span>
                  <span class="display-1 font-weight-black primary--text">{{ localMoney(totals.finalTotal) }} €</span>
                </div>
              </v-col>

              <!-- Payment Action Selection Grid Layout Matrix -->
              <v-col cols="12" md="7" class="border-left-desktop pl-md-6 py-0">
                <span class="title font-weight-bold text--secondary d-block mb-3">Vrsta plaćanja:</span>
                <v-item-group v-model="invoice.paymentMethod" mandatory>
                  <v-row dense>
                    <v-col v-for="method in paymentMethods" :key="method.value" cols="6" class="pa-2">
                      <v-item :value="method.value" v-slot:default>
                        <v-card
                          :color="invoice.paymentMethod === method.value ? 'primary' : 'white'"
                          :dark="invoice.paymentMethod === method.value"
                          outlined
                          class="text-center d-flex align-center justify-center cursor-pointer transition-swing elevation-1"
                          height="64"
                          @click="invoice.paymentMethod = method.value"
                        >
                          <span class="title font-weight-bold">
                            <v-icon left size="26" :dark="invoice.paymentMethod === method.value">{{ method.icon }}</v-icon>
                            {{ method.label }}
                          </span>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- Receipt Distribution Framework Toggle Layout -->
            <v-row class="align-center mb-4">
              <v-col cols="12" md="5">
                <v-btn-toggle v-model="deliveryMethod" mandatory color="info" class="d-flex border-all" height="54">
                  <v-btn value="print" class="flex-grow-1 text-none body-1 font-weight-medium"><v-icon left>mdi-printer</v-icon>Isprintaj</v-btn>
                  <v-btn value="email" class="flex-grow-1 text-none body-1 font-weight-medium"><v-icon left>mdi-email-outline</v-icon>Šalji na email</v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col cols="12" md="7">
                <v-slide-x-transition>
                  <v-text-field
                    v-if="deliveryMethod === 'email'"
                    v-model="invoice.email"
                    label="Email adresa kupca *"
                    outlined
                    hide-details
                    prepend-inner-icon="mdi-at"
                    placeholder="kupac@primjer.com"
                    class="white accessible-field"
                  ></v-text-field>
                </v-slide-x-transition>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- Receipt Distribution Framework Toggle Layout -->
            <v-row class="align-center mb-4">
              <v-col cols="12" md="7">
                  <v-btn @click="register" class="flex-grow-1 text-none body-1 font-weight-medium"><v-icon left>mdi-content-save-outline</v-icon>Spremi</v-btn>
                  <v-btn value="printoffer" class="flex-grow-1 text-none body-1 font-weight-medium"><v-icon left>mdi-printer</v-icon>Print kao ponuda</v-btn>
                  <v-btn value="printworkorder" class="flex-grow-1 text-none body-1 font-weight-medium"><v-icon left>mdi-printer</v-icon>Print kao radni nalog</v-btn>
              </v-col>
              <v-col cols="12" md="5">

              </v-col>
            </v-row>

            <!-- Final Process Button execution hook -->
            <v-btn block color="success" height="70" class="headline font-weight-black mt-2 elevation-2" :disabled="cartItems.length === 0" @click="handleInvoiceSubmission">
              <v-icon left size="30">{{ deliveryMethod === 'email' ? 'mdi-email-send' : 'mdi-check-circle' }}</v-icon>
              {{ isCardPayment ? 'Šaljem na terminal' : (deliveryMethod === 'email' ? 'Završi i šalji email' : 'Završi i isprintaj') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ACCESSIBLE MODAL SYSTEM: Async Blocking Overlay Dialog with Large Readable Layouts -->
    <v-dialog v-model="isProcessingTerminal" persistent max-width="550">
      <v-card color="indigo darken-4" dark class="text-center pa-8 tile">
        <v-card-text class="pt-4 white--text">
          <div class="display-1 font-weight-bold mb-4">POS Terminal Aktivan</div>
          <v-progress-circular indeterminate color="white" size="80" width="8" class="mb-6"></v-progress-circular>
          <div class="headline mb-2 font-weight-medium">Čekam autorizaciju...</div>
          <div class="display-2 yellow--text font-weight-black tracking-wide my-6">{{ localMoney(totals.finalTotal) }} €</div>
          <p class="title text--lighten-2 font-weight-light line-height-large">Molim uputite kupca da prisloni karticu i upiše pin na POS terminalu.</p>
        </v-card-text>
        <v-card-actions class="justify-center pb-2 mt-4">
          <v-btn color="error" x-large dark class="body-1 font-weight-bold px-6" outlined @click="abortTerminalPayment">Odustani & Vrati</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>

import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'
import TeyaService from '@/services/TeyaService'
import PartnerService from '@/services/PartnerService'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import { parseNum, round } from '@/snippets/allSnippets'
import moneyFormat from '@/snippets/moneyFormat'
import { defDocument } from './documentHelper'
import {defDocumentDetail, defNewDocumentDetail} from './documentHelper'
import POStestlist from './POStestlist'
import POStestlist2 from './POStestlist2'



export default {
  name: 'PosCompleteInvoiceEngine',
  data() {
    return {
      lang: {},
      langC: {},
      customerType: 'private',
      showPrivateVat: false,
      itemSearchModel: null,
      selectedPrivateClient: null,
      selectedCompanyClient: null,
      deliveryMethod: 'print',
      
      isProcessingTerminal: false,
      terminalTimeoutId: null,

      componentKey: 0,
      document: {},
      documentDet: {},
      documentItems: [],
      mainQuery: {},
      selectId: null,

      invoice: {
        date: new Date().toISOString().substr(0, 10),
        time: new Date().toTimeString().substr(0, 5),
        customerName: '',
        companyName: '',
        vatId: '',
        address: '',
        email: '',
        applyVat: true,
        comment: '',
        paymentMethod: 'cash',
        saveToDb: true
      },

      taxTiers: [
        { label: '25% PDV', value: 0.25 },
        { label: '13% PDV', value: 0.13 },
        { label: '5% PDV', value: 0.05 },
        { label: '0% Bez PDVa', value: 0.00 }
      ],

      paymentMethods: [
        { label: 'Gotovina', value: 'cash', icon: 'mdi-cash' },
        { label: 'Visa', value: 'visa', icon: 'mdi-credit-card' },
        { label: 'Mastercard', value: 'master', icon: 'mdi-credit-card-outline' },
        { label: 'Žiro račun', value: 'bank', icon: 'mdi-bank' }
      ],

      itemDatabase: [
        // { name: 'Wireless Mouse M123', price: 35.00, taxRate: 0.25 },
        // { name: 'USB-C Hub (6-in-1)', price: 89.00, taxRate: 0.25 },
        // { name: 'HDMI Cable (3m)', price: 12.50, taxRate: 0.13 },
        // { name: 'Fresh Espresso Beans (1kg)', price: 24.00, taxRate: 0.05 },
        // { name: 'International Shipping Duty', price: 15.00, taxRate: 0.00 }
      ],

      savedPrivateClients: [
        // { name: 'John Doe', vatId: 'HR987654321', email: 'john.doe@gmail.com' },
        // { name: 'Anna Smith', vatId: '', email: 'anna.s@outlook.com' }
      ],
      savedCompanies: [
        // { companyName: 'TechCorp Solutions Inc.', vatId: 'HR12345678901', address: '123 Business Ave, Zagreb', email: 'billing@techcorp.hr' },
        // { companyName: 'Global Trade d.o.o.', vatId: 'HR55544433322', address: 'Slavonska Avenija 4, Split', email: 'accounting@globaltrade.hr' }
      ],

      cartItems: []
    };
  },
  mounted(){
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    if (this.$store.state.partnerStore) {
      this.savedPrivateClients = this.$store.state.partnerStore.filter(par => par.privatePerson === true)
      this.savedCompanies = this.$store.state.partnerStore.filter(par => par.privatePerson === false)
    }
    this.itemDatabase = this.$store.state.itemStore ? this.$store.state.itemStore : []
    if (this.$store.state.editItem === 1) {
        this.documentName = this.$store.state.documentActiv
        this.documentNameLoc = this.$store.state.documentActivLoc        
        if (this.$store.state.documentActivHead) {
          this.document = this.$store.state.documentActivHead
          if (this.document.partnerId && parseInt(this.document.partnerId) > 0 ) {    
            this.selectId = parseInt(this.document.partnerId)
            const havePartner = this.partners.find(partner => (partner.id === parseInt(this.document.partnerId)))
            this.selectedPrivateClient = havePartner
            this.selectedCompanyClient = havePartner

            if (Object.keys(havePartner).length === 0) {
              const havePartByVAT = this.partners.find(partner => (partner.partnerVATID === (this.document.partnerVATID)))
              this.selectedPrivateClient = havePartByVAT
              this.selectedCompanyClient = havePartByVAT
              this.$store.dispatch('setPartnerid', this.selectPa.id)
            }
          }
          // this.selectBankId  =this.document.bankAccountId ? parseInt(this.document.bankAccountId) : null
          // this.selectBank = this.selectBankId ? this.banks.find(bank => (bank.id === this.selectBankId)) : null
          this.document.documentTime = this.document.documentTime ? this.document.documentTime.substr(0,5) : null
          this.show1 = this.document.documentDescription4 && this.document.documentDescription4.trim().length > 0 ? true : false
          this.show2 = this.document.documentDescription1 && this.document.documentDescription1.trim().length > 0 ? true : false
          this.show3 = this.document.documentDescription5 && this.document.documentDescription5.trim().length > 0 ? true : false
          this.show4 = this.document.documentDescription3 && this.document.documentDescription3.trim().length > 0 ? true : false

        } else {
          // if in any case dont have all data in head, return to list
          this.text = 'Error! Sorry... some error happend. Need to return.'
          this.color = 'red'
          this.snackbar = true
          this.timeout = 4000
            this.$router.push({
              name: 'documentposindex'
            })
        }
     }   
    // create NEW
    if (this.$store.state.editItem === 0) {
      this.document = defDocument()
      if (this.$store.state.companyid) {
        this.CompanyId = this.$store.state.companyid
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2026
      this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
      this.document.documentSide = this.$store.state.documentSide ? this.$store.state.documentSide : 0

      this.document.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
      this.document.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
      this.document.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
      this.document.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
      this.document.uservatID = this.$store.state.user.vatID ? this.$store.state.user.vatID : '12345678901'
      this.document.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      if (this.$store.state.documentActiv) {
        this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
        this.document.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
        this.docName = this.$store.state.documentActiv
        this.document.documentAnalysis = 2
        this.$store.dispatch('setDocumentAnalysis', 2)
      }
      this.document.documentSide = this.$store.state.documentSide ? this.$store.state.documentSide : 1  
      if (this.banks) {
        this.selectBank = this.banks ? this.banks.find(bank => (bank.DefaultAccount === true)) : {}
        this.selectBankId  = this.selectBank ? parseInt(this.selectBank.id) : null
      }
      const nrOfDays = 0
      this.document.documentDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentTime = dayjs(new Date()).format('HH:mm')
      this.document.documentInvoiceStartDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentInvoiceEndDate = dayjs(new Date()).add(nrOfDays, 'days').format('YYYY-MM-DD')
      this.document.documentInvoiceEndPeriodDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentHomeCurrency = 'EUR'
      this.document.documentForeignCurrency = 'EUR'
      this.document.documentExRate = 1
    }

  },
  computed: {
    isCardPayment() {
      return this.invoice.paymentMethod === 'visa' || this.invoice.paymentMethod === 'master';
    },

    totals() {
      let subtotal = 0;
      let taxLedger = { 0.25: 0, 0.13: 0, 0.05: 0, 0.00: 0 };

      this.cartItems.forEach(item => {
        const netItemUnitPrice = item.basePrice - item.discount;
        const netRowTotal = netItemUnitPrice * item.qty;
        
        subtotal += netRowTotal;

        if (this.invoice.applyVat && item.taxRate > 0) {
          const rowCalculatedTax = netRowTotal * item.taxRate;
          taxLedger[item.taxRate] += rowCalculatedTax;
        }
      });

      const totalTax = Object.values(taxLedger).reduce((acc, curr) => acc + curr, 0);
      const finalTotal = subtotal + totalTax;

      return { subtotal, taxLedger, totalTax, finalTotal };
    }
  },

  watch: {
    'selectedPrivateClient' () {
      if (!this.selectedPrivateClient) {
        this.clearAllPartnerData()
      }
    },
    'selectedCompanyClient' () {
      if (!this.selectedCompanyClient) {
        this.clearAllPartnerData()
      }
    },
    
    customerType() {
     // this.selectedPrivateClient = null;
     // this.selectedCompanyClient = null;
     this.clearAllPartnerData()
    }
  },

  methods: {
    clearAllPartnerData() {
      this.clearPartner()
      this.invoice = {
        date: new Date().toISOString().substr(0, 10),
        time: new Date().toTimeString().substr(0, 5),
        customerName: '',
        companyName: '',
        vatId: '',
        address: '',
        email: '',
        applyVat: true,
        comment: '',
        paymentMethod: 'cash',
        saveToDb: true
      }
    },
    recalculateFromBase(item) {
      console.log('item: ', item);
      
      const activeTaxRate = this.invoice.applyVat ? item.taxRate : 0;
      item.targetGross = Number(((item.basePrice - item.discount) * (1 + activeTaxRate)).toFixed(2));
    },
    localMoney(moneyToFormat) {
        return moneyFormat(moneyToFormat)
    },
    recalculateFromDiscount(item) {
      this.recalculateFromBase(item);
    },

    recalculateFromTargetGross(item) {
      if (!item.targetGross || item.targetGross <= 0) {
        item.discount = 0;
        return;
      }
      const activeTaxRate = this.invoice.applyVat ? item.taxRate : 0;
      const targetNetUnitPrice = item.targetGross / (1 + activeTaxRate);
      item.discount = Number((item.basePrice - targetNetUnitPrice).toFixed(4));
    },

    handleItemSelection(val) {
      if (!val) return;

      if (typeof val === 'object') {
        console.log('val objekt', val)
        this.documentDet = defDocumentDetail()
        this.documentDet = {...this.documentDet, ...defNewDocumentDetail()}
        const newId = this.getRndInteger(1000000000, 9000000000)

        this.documentDet.itemID = val.itemID
        this.documentDet.itemName = val.itemName
        this.documentDet.ItemNameShort = val.ItemNameShort
        this.documentDet.ItemCode = val.ItemCode
        this.documentDet.ItemEANCode = val.ItemEANCode
        this.documentDet.itemUnit = val.itemUnit
        if (val.GroupId) {
          this.documentDet.itemGroup = val.GroupId
        }
        if (val.itemGroup) {
          this.documentDet.itemGroup = val.itemGroup
        }

        this.documentDet.itemGroupName = val.GroupName ? val.GroupName : ''

        this.documentDet.itemSuppBasePrice = val.itemSuppBasePrice
        this.documentDet.itemSuppBasePriceAmount = val.itemSuppBasePrice
        this.documentDet.itemSuppPrice = val.itemSuppPrice
        this.documentDet.itemSuppPriceAmount = val.itemSuppPrice
        this.documentDet.ItemSuppCode = val.ItemSuppCode


        this.documentDet.itemPrice = val.itemPrice
        this.documentDet.itemVAT1Percentage = val.itemVAT1Percentage
        this.documentDet.itemVAT1Amount = val.itemPriceWithVAT - val.itemPrice
        this.documentDet.itemVAT2Percentge = val.itemVAT2Percentge
        this.documentDet.itemVAT2Amount = 0
        this.documentDet.itemDirectDuty1 = val.itemiDirectDuty1
        this.documentDet.itemDirectDuty2 = 0
        this.documentDet.itemPriceWithVAT = val.itemPriceWithVAT
        this.documentDet.itemPcsPlus = 0
        this.documentDet.itemPcsMinus = 1
        this.documentDet.itemPcsNeutral = 0
        this.documentDet.itemService = val.itemService

        this.documentDet.ItemHomeCurrency = 'EUR'
        this.documentDet.ItemForeignCurrency = 'EUR'
        this.documentDet.ItemExRate = 1

        this.documentDet.itemBaseAmount = val.itemPrice
        this.documentDet.itemBaseForeAmount = val.itemPrice
        this.documentDet.itemDiscountAmount1 = 0
        this.documentDet.itemDiscountForeAmount1 = 0
        this.documentDet.itemDiscountPercentage1 = 0
        this.documentDet.itemDiscountAmount2 = 0
        this.documentDet.itemDiscountPercentage2 = 0
        this.documentDet.itemDiscountAmount3 = 0
        this.documentDet.itemDiscountPercentage4 = 0
        this.documentDet.itemDiscountPrice = val.itemPrice
        this.documentDet.itemDiscountForePrice = val.itemPrice
 
        this.documentDet.itemBaseAmountNoVAT = val.itemPrice
        this.documentDet.itemBaseForeAmountNoVAT = val.itemPrice
        this.documentDet.itemBaseAmountWithVAT = val.itemPriceWithVAT
        this.documentDet.itemBaseForeAmountWithVAT = val.itemPriceWithVAT
        this.documentDet.itemAmountWithVAT = this.iAmountWithVAT
        this.documentDet.itemFullTotal = val.itemPriceWithVAT
        this.documentDet.itemFullTotalFore = val.itemPriceWithVAT

        this.documentDet.id = newId

        this.documentItems.push(this.documentDet)

        this.addCartItem(val.itemName, val.itemPriceWithVAT, round((val.itemVAT1Percentage/100),2));
      }
      this.$nextTick(() => { this.itemSearchModel = null; });
    },
    addCustomItemDirectly() {
      if (!this.itemSearchModel) return;
      const cleanName = typeof this.itemSearchModel === 'string' ? this.itemSearchModel : this.itemSearchModel.name;
      this.addCartItem(cleanName, 0.00, 0.25);
      this.$nextTick(() => { this.itemSearchModel = null; });
    },
    addCartItem(name, basePrice, taxRate) {
      const existing = this.cartItems.find(i => i.name.toLowerCase() === name.toLowerCase() && i.taxRate === taxRate);
      if (existing) {
        existing.qty++;
        this.recalculateFromBase(existing);
      } else {
        let newItem = { name, qty: 1, basePrice, taxRate, discount: 0, targetGross: 0 };
        this.recalculateFromBase(newItem);
        this.cartItems.push(newItem);
      }
    },
    removeItem(idx) { 
      this.cartItems.splice(idx, 1); 
    },

    async onPrivateClientSelect(val) {
      if (val && typeof val === 'object') {
        await this.findPartner(val.id)
        this.invoice.email = val.email || '';
      } else if (typeof val === 'string') {
        this.document.partnerName = val;
      }
    },
    async onCompanySelect(val) {
      if (val && typeof val === 'object') {
        await this.findPartner(val.id)
        this.invoice.address = val. partnerStreet + ' ' + val.partnerBuildingNameNumber + ', ' + val.partnerPostcode + ' ' + val.partnerCity;
        this.invoice.email = val.partneremail || '';
      }
    },
    async findPartner(byId) {
        const locPartner =  (await PartnerService.findbyid(byId)).data.partner
        if (locPartner) {
          this.setPartner(locPartner)
        }
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },

    async verifyVatCompany() {
      //alert(`Tražim partnera po OIBu: ${this.document.partnerVATID}`);
      const checkPartner = {}
      checkPartner.CompanyId = this.$store.state.companyid
      checkPartner.partnerVATID = this.document.partnerVATID
      const {data} = await PartnerService.check(checkPartner)
      if (data && data.partner) {
        this.setPartner(data.partner)
      }
    },

    setPartner(locPartner) {
        this.document.partnerId = locPartner.id
        this.document.partnerName = locPartner.partnerName
        this.document.partnerNameShort = locPartner.partnerNameShort
        this.document.partnerNameDatabase = locPartner.partnerNameDatabase
        this.document.partnerBuildingNameNumber = locPartner.partnerBuildingNameNumber
        this.document.partnerStreet = locPartner.partnerStreet
        this.document.partnerCity = locPartner.partnerCity
        this.document.partnerPostcode = locPartner.partnerPostcode
        this.document.partnerCountyRegion = locPartner.partnerCountyRegion
        this.document.partnerState = locPartner.partnerState
        this.document.partnerVATID = locPartner.partnerVATID
        this.document.partneremail = locPartner.partneremail
        this.document.partnerPhones = locPartner.partnerPhones
        this.document.partnerBankName = locPartner.partnerBankName
        this.document.partnerBankAddress = locPartner.partnerBankAddress
        this.document.partnerBankIBAN = locPartner.partnerBankIBAN
        this.document.partnerBankSWIFT = locPartner.partnerBankSWIFT
        this.document.partnerContactTime = locPartner.partnerContactTime
        this.document.partnerSecretaryTitle = locPartner.partnerSecretaryTitle
        this.document.partnerSecretaryFirst = locPartner.partnerSecretaryFirst
        this.document.partnerSecretaryLast = locPartner.partnerSecretaryLast
        this.document.partnerSecretaryEmail = locPartner.partnerSecretaryEmail
        this.document.partnerSecretaryPhone = locPartner.partnerSecretaryPhone
        this.document.partnerSecretaryContactOption = locPartner.partnerSecretaryContactOption
        this.document.privatePerson = locPartner.privatePerson
    },

    handleInvoiceSubmission() {
      if (this.customerType === 'company' && (!this.document.partnerName || !this.document.partnerVATID)) {
        alert('Molim ispunite potrebna polja za firmu.');
        return;
      }
      if (this.deliveryMethod === 'email' && !this.invoice.email) {
        alert('Za slanje računa ne email, treba validna email adresa!');
        return;
      }

      this.makeSum()

      if (this.isCardPayment) {
        this.executeTerminalHandshake();
      } else {
        this.commitInvoiceFinalData();
      }
    },

    makeSum() {
      const updateSumObject = {
        documentDescription9: 0,
        documentDescription10: 0,
        documentTotalVAT1Per: 0,
        documentTotalVAT1Base: 0,
        documentTotalVAT1Amount: 0,
        documentTotalVAT2Per: 0,
        documentTotalVAT2Base: 0,
        documentTotalVAT2Amount: 0,
        documentTotalVAT3Per: 0,
        documentTotalVAT3Base: 0,
        documentTotalVAT3Amount: 0,
        documentTotalVAT4Per: 0,
        documentTotalVAT4Base: 0,
        documentTotalVAT4Amount: 0,
        documentTotalVAT5Per: 0,
        documentTotalVAT5Base: 0,
        documentTotalVAT5Amount: 0,
        documentTotalAmountNetto: 0,
        documentTotalAmountVAT: 0,
        documentTotalAmountBrutto: 0,
        documentTotalAmountPayInAdvance: this.$store.state.documentActivHead.documentTotalAmountPayInAdvance ? parseFloat(this.$store.state.documentActivHead.documentTotalAmountPayInAdvance) : 0,
        documentTotalAmountToPay: 0,
        documentTotalAmountNettoForeign: 0,
        documentTotalAmountVATForeign: 0,
        documentTotalAmountBruttoForeign: 0,
        documentTotalAmountPayInAdvanceForeign: 0,
        documentTotalAmountToPayForeign: 0,
        documentTotalAmountDirectD1: 0,
        documentTotalAmountDirectD2: 0,
        documentTotalAmountDirectD1Fore: 0,
        documentTotalAmountDirectD2Fore: 0,
        supplierAmount: 0,
        supplierNetoAmount: 0,
        supplierDiscount: 0,
        supplierMargin: 0,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
      }
      let dSide = 2

      const hrVat1 = 25
      const hrVat2 = 13
      const hrVat3 = 5

      if (this.documentItems) {
        this.documentItems.map(documentDet => {
          this.pcsLoc = 0
          if (dSide === 1 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsPlus) ? parseFloat(documentDet.itemPcsPlus)  : 0
          }
          if (dSide === 2 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsMinus) ? parseFloat(documentDet.itemPcsMinus)  : 0
          }
          if (dSide === 3 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsNeutral) ? parseFloat(documentDet.itemPcsNeutral)  : 0
          }
          this.pcsLoc = round(this.pcsLoc, 3)     
          
          if ((documentDet.itemSuppBasePriceAmount)) {
            updateSumObject.supplierAmount += round((documentDet.itemSuppBasePriceAmount),2)
          }
          if (documentDet.itemSuppDiscountAmount) {
            updateSumObject.supplierDiscount += round(documentDet.itemSuppDiscountAmount,2)
          }
          if (documentDet.itemSuppPriceAmount) {
            updateSumObject.supplierNetoAmount += round(documentDet.itemSuppPriceAmount,2)
          }
          if (documentDet.itemBaseAmount) {
            updateSumObject.documentDescription9 += parseFloat(documentDet.itemBaseAmount)
          }
          if (documentDet.itemBaseAmountNoVAT) {
            updateSumObject.documentTotalAmountNetto += parseFloat(documentDet.itemBaseAmountNoVAT)
          }
          // if (documentDet.itemVAT1Amount) {
          //   updateSumObject.documentTotalAmountVAT += parseFloat(documentDet.itemVAT1Amount)
          // }
          //const dD1 = documentDet.itemDirectDuty1Amount ? parseFloat(documentDet.itemDirectDuty1Amount) : 0
          // if (documentDet.itemAmountWithVAT) {
          //   updateSumObject.documentTotalAmountBrutto += parseFloat(documentDet.itemAmountWithVAT) + dD1
          // }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat1) {
            updateSumObject.documentTotalVAT1Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT1Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT1Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat2) {
            updateSumObject.documentTotalVAT2Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT2Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT2Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat3) {
            updateSumObject.documentTotalVAT3Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT3Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT3Base += (parseFloat(documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (documentDet.itemBaseAmount) {
            if (parseInt(documentDet.FreeF1) === 1) {
              updateSumObject.FreeF1 += parseFloat(documentDet.itemBaseAmount)
            }
            if (parseInt(documentDet.FreeF1) === 2) {
              updateSumObject.FreeF2 += parseFloat(documentDet.itemBaseAmount)
              updateSumObject.FreeF5 += parseFloat(documentDet.empWrkHrs)
            }
            if (parseInt(documentDet.FreeF1) === 3) {
              updateSumObject.FreeF3 += parseFloat(documentDet.itemBaseAmount)
            }
          }
          if (documentDet.itemBaseAmountNoVAT) {
            if (round(parseFloat(documentDet.itemVAT1Amount),2) === 0) {
              updateSumObject.FreeF4 += parseFloat(documentDet.itemBaseAmountNoVAT)
            }
          }
          if (documentDet.itemDirectDuty1Amount) {
            updateSumObject.documentTotalAmountDirectD1+= parseFloat(documentDet.itemDirectDuty1Amount)
          }
        })
      }

      updateSumObject.documentTotalAmountNetto = updateSumObject.documentTotalAmountNetto ? round(updateSumObject.documentTotalAmountNetto, 2) : 0
      updateSumObject.documentTotalVAT1Amount  = round((updateSumObject.documentTotalVAT1Base * ( (hrVat1/100))),2)
      updateSumObject.documentTotalVAT2Amount  = round((updateSumObject.documentTotalVAT2Base * ( (hrVat2/100))),2)
      updateSumObject.documentTotalVAT3Amount  = round((updateSumObject.documentTotalVAT3Base * ( (hrVat3/100))),2)
      updateSumObject.documentDescription9 = updateSumObject.documentDescription9 ? round(updateSumObject.documentDescription9, 2) : 0
      updateSumObject.supplierNetoAmount = updateSumObject.supplierNetoAmount ? round(updateSumObject.supplierNetoAmount, 2) : 0
      updateSumObject.supplierMargin = round(updateSumObject.documentTotalAmountNetto - updateSumObject.supplierNetoAmount, 2)
      updateSumObject.documentTotalAmountVAT = updateSumObject.documentTotalVAT1Amount + updateSumObject.documentTotalVAT2Amount + updateSumObject.documentTotalVAT3Amount
      updateSumObject.documentTotalAmountBrutto = updateSumObject.documentTotalAmountNetto + updateSumObject.documentTotalAmountVAT
      updateSumObject.documentTotalVAT1Per = hrVat1 ? round(hrVat1, 2) : 0
      updateSumObject.documentTotalVAT2Per = hrVat2 ? round(hrVat2, 2) : 0
      updateSumObject.documentTotalVAT3Per = hrVat3 ? round(hrVat3, 2) : 0

      // updateSumObject.documentTotalVAT1Base = hrVat1 && updateSumObject.documentTotalVAT1Amount ? round(updateSumObject.documentTotalVAT1Amount / (hrVat1/100), 2) : 0
      // updateSumObject.documentTotalVAT2Base = hrVat2 && updateSumObject.documentTotalVAT2Amount ? round(updateSumObject.documentTotalVAT2Amount / (hrVat2/100), 2) : 0
      // updateSumObject.documentTotalVAT3Base = hrVat3 && updateSumObject.documentTotalVAT3Amount ? round(updateSumObject.documentTotalVAT3Amount / (hrVat3/100), 2) : 0
      updateSumObject.FreeF1 = updateSumObject.FreeF1 ? round(updateSumObject.FreeF1, 2) : 0
      updateSumObject.FreeF2 = updateSumObject.FreeF2 ? round(updateSumObject.FreeF2, 2) : 0
      updateSumObject.FreeF3 = updateSumObject.FreeF3 ? round(updateSumObject.FreeF3, 2) : 0
      updateSumObject.FreeF4 = updateSumObject.FreeF4 ? round(updateSumObject.FreeF4, 2) : 0
      updateSumObject.FreeF5 = updateSumObject.FreeF5 ? round(updateSumObject.FreeF5, 2) : 0
      updateSumObject.documentDescription10 = updateSumObject.documentDescription9 - updateSumObject.documentTotalAmountNetto
      updateSumObject.documentTotalAmountPayInAdvance = updateSumObject.documentTotalAmountPayInAdvance ? round(updateSumObject.documentTotalAmountPayInAdvance, 2) : 0
      updateSumObject.documentTotalAmountToPay = updateSumObject.documentTotalAmountBrutto ? (round(updateSumObject.documentTotalAmountBrutto, 2) - (updateSumObject.documentTotalAmountPayInAdvance )): 0

      updateSumObject.documentTotalAmountNettoForeign = updateSumObject.documentTotalAmountNetto ? round((updateSumObject.documentTotalAmountNetto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountVATForeign = updateSumObject.documentTotalAmountVAT ? round((updateSumObject.documentTotalAmountVAT / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountBruttoForeign = updateSumObject.documentTotalAmountBrutto ? round((updateSumObject.documentTotalAmountBrutto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountPayInAdvanceForeign = round((updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate), 2)
      updateSumObject.documentTotalAmountToPayForeign = updateSumObject.documentTotalAmountBrutto ? (round((updateSumObject.documentTotalAmountBrutto/ this.ExRate), 2) - (updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate) ) : 0
      updateSumObject.documentTotalAmountDirectD1Fore = updateSumObject.documentTotalAmountDirectD1 ? round((updateSumObject.documentTotalAmountDirectD1 / this.ExRate), 2) : 0

      const newHead = {...this.$store.state.documentActivHead, ...updateSumObject}
      if (newHead) {
          this.$store.dispatch('setDocumentActivHead', newHead)
        } else {
          this.$store.dispatch('setDocumentActivHead', {})
        }
    },

    async executeTerminalHandshake() {
      try {
        this.isProcessingTerminal = true;

        const sendQuery = {}
        sendQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 1
        sendQuery.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
        sendQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2020
        sendQuery.documentName = 'POS'
        sendQuery.amount = 0.01
        sendQuery.invoiceId = this.getRndInteger(100000, 900000)
        sendQuery.posAppId = '1'
        sendQuery.posAppName = 'CEgrupa'
        sendQuery.DatumIzvrsenja = new Date()

        const res = TeyaService.initiate(sendQuery)
        console.log('TeyaService res: ', res);
        
        this.terminalTimeoutId = setTimeout(() => {
          this.isProcessingTerminal = false;
          alert('Terminal je verifcirao karticu. Plaćanje je potvrđeno. Možete zaključiti račun');
          this.commitInvoiceFinalData();
        }, 4500);
      } catch (err) {
        console.log('Teya initiat err: ', err);
        }
    },

    abortTerminalPayment() {
      clearTimeout(this.terminalTimeoutId);
      this.isProcessingTerminal = false;
      alert('Transakcija je prekinuta. Moguće je došlo do greške. Novac nije skinut!');
    },

    commitInvoiceFinalData() {
      const payload = {
        meta: { customerType: this.customerType, deliveryMethod: this.deliveryMethod, paymentType: this.invoice.paymentMethod },
        billing: { ...this.invoice },
        cart: this.cartItems,
        accounting: { ...this.totals }
      };
      console.log('1  Glava ', this.document);
      console.log('2. detalji ', this.documentItems);
      console.log('Podaci u bazu uspješno upisani! ', payload);
      alert(this.deliveryMethod === 'email' ? 'email Račun je uspješno poslan!' : 'Račun je ispisan uspješno!');
      this.cartItems = [];
    },
    clearPartner() {
      this.selectPa = null
      this.document.partnerId = null
      this.document.partnerName = null
      this.document.partnerNameShort = null
      this.document.partnerNameDatabase = null
      this.document.partnerBuildingNameNumber = null
      this.document.partnerStreet = null
      this.document.partnerCity = null
      this.document.partnerPostcode = null
      this.document.partnerCountyRegion = null
      this.document.partnerState = null
      this.document.partnerVATID = null
      this.document.partneremail = null
      this.document.partnerPhones = null
      this.document.partnerBankName = null
      this.document.partnerBankAddress = null
      this.document.partnerBankIBAN = null
      this.document.partnerBankSWIFT = null
      this.document.partnerContactTime = null
      this.document.partnerSecretaryTitle = null
      this.document.partnerSecretaryFirst = null
      this.document.partnerSecretaryLast = null
      this.document.partnerSecretaryEmail = null
      this.document.partnerSecretaryPhone = null
      this.document.partnerSecretaryContactOption = null
      this.document.privatePerson = false
    },

    async findPartner (findQuery) {
      //console.log('trazim  FIND PARTNER findQuery', findQuery, 'this.findpartnerbyid  ', this.findpartnerbyid )
      //if (partnerVATID.length > 0) {
        //const locPartner = !this.findpartnerbyid ? (await PartnerService.show(findQuery)).data.partner : (await PartnerService.findbyid(findQuery)).data.partner
        const locPartner =  (await PartnerService.findbyid(findQuery)).data.partner
        this.document.partnerId = locPartner.id
        this.document.partnerName = locPartner.partnerName
        this.document.partnerNameShort = locPartner.partnerNameShort
        this.document.partnerNameDatabase = locPartner.partnerNameDatabase
        this.document.partnerBuildingNameNumber = locPartner.partnerBuildingNameNumber
        this.document.partnerStreet = locPartner.partnerStreet
        this.document.partnerCity = locPartner.partnerCity
        this.document.partnerPostcode = locPartner.partnerPostcode
        this.document.partnerCountyRegion = locPartner.partnerCountyRegion
        this.document.partnerState = locPartner.partnerState
        this.document.partnerVATID = locPartner.partnerVATID
        this.document.partneremail = locPartner.partneremail
        this.document.partnerPhones = locPartner.partnerPhones
        this.document.partnerBankName = locPartner.partnerBankName
        this.document.partnerBankAddress = locPartner.partnerBankAddress
        this.document.partnerBankIBAN = locPartner.partnerBankIBAN
        this.document.partnerBankSWIFT = locPartner.partnerBankSWIFT
        this.document.partnerContactTime = locPartner.partnerContactTime
        this.document.partnerSecretaryTitle = locPartner.partnerSecretaryTitle
        this.document.partnerSecretaryFirst = locPartner.partnerSecretaryFirst
        this.document.partnerSecretaryLast = locPartner.partnerSecretaryLast
        this.document.partnerSecretaryEmail = locPartner.partnerSecretaryEmail
        this.document.partnerSecretaryPhone = locPartner.partnerSecretaryPhone
        this.document.partnerSecretaryContactOption = locPartner.partnerSecretaryContactOption
        this.document.privatePerson = locPartner.privatePerson

    //    this.selectPa = !this.findpartnerbyid ? this.selectPa = this.partners.find(partner => (partner.partnerVATID === (this.document.partnerVATID))) : this.selectPa = this.partners.find(partner => (partner.id === parseInt(this.document.partnerId)))
        this.$store.dispatch('setPartnerid', locPartner.id)
        //   }
        // }
     // }
    },

    async register () {
      try {
        // write new document to database
        // this.localError = false   
        console.log('Snimam 0', this.$store.state.businessYear)
        const haveYear = dayjs(this.document.documentDate).year()
        if (haveYear !== this.$store.state.businessYear) {
          this.text = this.lang.wrongBussinesYear
          this.color = 'red'
          this.snackbar = true
          this.timeout = 3000
          return
        }
        console.log('Snimam 1')
        this.makeSum()

        // if (!this.document.exportDoc) {
        //   const partVatLeght = this.document.partnerVATID.trim().length
        //   if (partVatLeght !== 11) {
        //     this.text = this.lang.PartnerErrorVAT3
        //     this.color = 'red'
        //     this.snackbar = true
        //     this.timeout = 3000
        //     this.reqVATID = true
        //     return
        //   }
        // }
             this.document.documentExRate = 1
         console.log('SAVING this.$store.state.editItem: ', this.$store.state.editItem);
            // create NEW
            if (this.$store.state.editItem === 0) {
             
              this.document.documentId = null

              if (!this.document.partnerNameShort || (this.document.partnerNameShort.trim()).length < 1) {
                this.document.partnerNameShort = this.document.partnerName.replace(/[\W_]/g, '')
              }
              if (!this.document.partnerNameDatabase || (this.document.partnerNameDatabase.trim()).length < 1) {
                this.document.partnerNameDatabase = this.document.partnerName.replace(/[\W_]/g, '')
              }
              this.document.status = 'Nefiskaliziran'
              const lastNr = {}
              const side = 2
              lastNr.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
              lastNr.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
              if (side === 1 || side === 2) {
                lastNr.WareHouseId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1
              }
              lastNr.documentName = this.documentName

              this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
              this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
             
              console.log('lastNr on doc create', lastNr)
              this.document.documentId = parseInt((await DocumentService.choose(lastNr)).data.docNumber)
              if (this.document.documentId && this.document.documentId > 0)
              {
                this.document.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.document.documentId + '-' + (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
                this.document.WareHouseId = (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
                const whObj =  this.$store.state.warehouseState ? this.$store.state.warehouseState.find(whID => whID.WareHouseId === this.$store.state.warehousemarkid) : []
                this.document.WareHouseName = whObj && whObj.WareHouseName ? whObj.WareHouseName : ''
                await DocumentService.post(this.document)
                  .then(async(response) => {
                    await this.saveItems()
                    this.text = this.lang.DocumentSavedOK + response.statusText
                    this.color = 'green'
                    this.snackbar = true
                    this.timeout = 2000
                    this.$store.dispatch('seteditItem', 0)
                    this.$store.dispatch('setDocumentActivHead', {})
                    this.$store.dispatch('setDocumentActivItems', [])
                    const newDoc = response.data && response.data.newDoc ? response.data.newDoc : null
                    if (newDoc) {
                      this.navigateTo(newDoc)
                    }
                  })
                  .catch(err => {
                    // eslint-disable-next-line
                    console.log(err)
                    this.text = 'Error post!' + err
                    this.color = 'red'
                    this.snackbar = true
                    this.timeout = 4000
                  })
              }
              
            }
            // edit current
            if (this.$store.state.editItem === 1) {
              await DocumentService.put(this.document)
                .then(async(response) => {
                  await this.saveItems()
                  this.text = this.lang.DocumentSavedOK + response.statusText
                  this.color = 'green'
                  this.snackbar = true
                  this.timeout = 2000
                  this.$store.dispatch('seteditItem', 0)
                  this.$store.dispatch('setDocumentActivHead', {})
                  this.$store.dispatch('setDocumentActivItems', [])
                  const newDoc = response.data && response.data.newDoc ? response.data.newDoc : null
                  if (newDoc) {
                    this.navigateTo(newDoc)
                  } else {
                    this.documentlist()
                  }
                })
                .catch(err => {
                  // eslint-disable-next-line
                  console.log(err)
                  this.text = 'Error put!' + err
                  this.color = 'red'
                  this.snackbar = true
                  this.timeout = 4000
                })
            }
      
      } catch (error) {
        // eslint-disable-next-line
        console.log(error)
        this.text = 'Error on save!' + error
        this.color = 'red'
        this.snackbar = true
        this.timeout = 4000
        this.error = 'Error'
      }
    },

    async saveItems() {
          if (this.documentItems) {
            await DocumentDetailService.saveitems(this.documentItems).then(res => {
              this.text = this.langC.DocumentSaved + (res && res.data && res.data.message ? res.data.message : '')
              this.color = 'green'
              this.snackbar = true
            }).catch(err => {
              this.text = this.langC.DocumentSaveError + (err.data)
              this.color = 'red'
              this.snackbar = true
            })
          }
    }
  },
  components: {
    POStestlist,
    POStestlist2
  }
};
</script>

<style scoped>
.border-all { border: 2px solid rgba(0, 0, 0, 0.15) !important; }
.border-top { border-top: 2px solid rgba(0, 0, 0, 0.15) !important; }
.cursor-pointer { cursor: pointer; }
.line-height-large { line-height: 1.6; }

@media (min-width: 960px) {
  .border-left-desktop { border-left: 2px solid rgba(0, 0, 0, 0.15) !important; }
}

/* Accessible Forms: Increase font sizing for text fields, dropdown selections and input indicators */
.accessible-field >>> .v-label { font-size: 1.15rem !important; }
.accessible-field >>> input { font-size: 1.15rem !important; padding: 12px 0 !important; }
.accessible-field >>> .v-input__slot { min-height: 56px !important; }

/* Scale up custom checkboxes and switch text targets */
.v-input--accessible-checkbox >>> .v-label { font-size: 1.2rem !important; font-weight: 500; color: #424242 !important; }
.v-input--accessible-checkbox >>> .v-icon { font-size: 28px !important; }
.v-input--accessible-switch >>> .v-label { font-size: 1.2rem !important; font-weight: bold; color: #2e7d32 !important; }

/* Accessible Datatable Configurations */
.accessible-table th { height: 60px !important; font-size: 1.1rem !important; }
.table-row-large td { height: 70px !important; border-bottom: 1px solid rgba(0,0,0,0.12) !important; }

/* In-table raw spreadsheet configuration adjustments */
.plain-text-field >>> .v-input__slot:before, .plain-text-field >>> .v-input__slot:after { display:none !important; }
.plain-text-field >>> .v-input__slot { padding: 0 !important; }
.center-input >>> input { text-align: center; font-size: 1.15rem !important; }
.center-input >>> .v-select__selection { width: 100%; text-align: center; justify-content: center; font-size: 1.15rem !important; }
.right-input >>> input { text-align: right; font-size: 1.15rem !important; font-weight: 500; }
.generic-gross-field >>> input { color: #1565C0 !important; font-weight: bold; }
</style>